var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotificationMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7737 6.33341L21.1337 8.69341L14.4937 15.3334H12.1337V12.9734L18.7737 6.33341ZM23.1337 5.74675L21.7203 4.33341C21.4537 4.06675 21.0403 4.06675 20.7737 4.33341L19.6403 5.46675L22.0003 7.82675L23.1337 6.69341C23.4003 6.42675 23.4003 6.00008 23.1337 5.74675ZM19.3337 14.2667V20.6667H22.0003V23.3334H0.666992V20.6667H3.33366V11.3334C3.33366 7.61341 5.88033 4.48008 9.33366 3.60008V2.66675C9.33366 1.56008 10.227 0.666748 11.3337 0.666748C12.4403 0.666748 13.3337 1.56008 13.3337 2.66675V3.60008C14.427 3.88008 15.427 4.38675 16.2803 5.05341L14.3737 6.96008C13.5203 6.34675 12.467 6.00008 11.3337 6.00008C8.38699 6.00008 6.00033 8.38675 6.00033 11.3334V20.6667H16.667V16.9334L19.3337 14.2667ZM8.66699 24.6667H14.0003C14.0003 26.1334 12.8003 27.3334 11.3337 27.3334C9.86699 27.3334 8.66699 26.1334 8.66699 24.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationMenu);
export default __webpack_public_path__ + "static/media/icon_notification_menu.3a257eb5a2f2ffb3ed647b53ee9ae210.svg";
export { ForwardRef as ReactComponent };